export const getPoolRequest = (state, id) => state.poolRequest.poolRequests.entries[id];
